/**
 * Sexy Princess Lingerie - Premium Animations
 * Scroll reveals, hover effects, and micro-interactions
 */

(function() {
  'use strict';

  // Intersection Observer for scroll animations
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  };

  const animationObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Add stagger delay based on data attribute or index
        const delay = entry.target.dataset.delay || 0;
        setTimeout(() => {
          entry.target.classList.add('animate-visible');
        }, delay);
        animationObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Initialize animations when DOM is ready
  function initAnimations() {
    // Select all elements with animation classes
    const animatedElements = document.querySelectorAll(
      '.animate-on-scroll, .animate-fade-up, .animate-fade-in, .animate-fade-left, .animate-fade-right, .animate-scale, .animate-stagger'
    );

    animatedElements.forEach((el) => {
      animationObserver.observe(el);
    });

    // Stagger children animations
    const staggerContainers = document.querySelectorAll('.stagger-children');
    staggerContainers.forEach((container) => {
      const children = container.children;
      Array.from(children).forEach((child, index) => {
        child.classList.add('animate-fade-up');
        child.dataset.delay = index * 100;
        animationObserver.observe(child);
      });
    });
  }

  // Counter animation for numbers
  function animateCounters() {
    const counters = document.querySelectorAll('.animate-counter');
    counters.forEach((counter) => {
      const target = parseInt(counter.dataset.target) || parseInt(counter.textContent);
      const duration = 2000;
      const step = target / (duration / 16);
      let current = 0;

      const updateCounter = () => {
        current += step;
        if (current < target) {
          counter.textContent = Math.floor(current);
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = target;
        }
      };

      const counterObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          updateCounter();
          counterObserver.unobserve(counter);
        }
      }, { threshold: 0.5 });

      counterObserver.observe(counter);
    });
  }

  // Parallax effect for hero sections
  function initParallax() {
    const parallaxElements = document.querySelectorAll('.parallax-bg');

    if (parallaxElements.length === 0) return;

    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrolled = window.pageYOffset;
          parallaxElements.forEach((el) => {
            const speed = el.dataset.speed || 0.5;
            el.style.transform = `translateY(${scrolled * speed}px)`;
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // Magnetic button effect
  function initMagneticButtons() {
    const magneticButtons = document.querySelectorAll('.magnetic-btn');

    magneticButtons.forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        btn.style.transform = `translate(${x * 0.3}px, ${y * 0.3}px)`;
      });

      btn.addEventListener('mouseleave', () => {
        btn.style.transform = 'translate(0, 0)';
      });
    });
  }

  // Smooth reveal for images
  function initImageReveals() {
    const images = document.querySelectorAll('.reveal-image');

    images.forEach((img) => {
      const imageObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          img.classList.add('revealed');
          imageObserver.unobserve(img);
        }
      }, { threshold: 0.3 });

      imageObserver.observe(img);
    });
  }

  // Text reveal animation
  function initTextReveals() {
    const textElements = document.querySelectorAll('.reveal-text');

    textElements.forEach((el) => {
      const text = el.textContent;
      el.innerHTML = '';

      text.split('').forEach((char, i) => {
        const span = document.createElement('span');
        span.textContent = char === ' ' ? '\u00A0' : char;
        span.style.animationDelay = `${i * 0.03}s`;
        span.classList.add('char');
        el.appendChild(span);
      });
    });
  }

  // Tilt effect for cards
  function initTiltEffect() {
    const tiltCards = document.querySelectorAll('.tilt-card');

    tiltCards.forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = (y - centerY) / 10;
        const rotateY = (centerX - x) / 10;

        card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      });

      card.addEventListener('mouseleave', () => {
        card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale3d(1, 1, 1)';
      });
    });
  }

  // Ripple effect for buttons
  function initRippleEffect() {
    const rippleButtons = document.querySelectorAll('.ripple-btn, .box-card__button');

    rippleButtons.forEach((btn) => {
      btn.addEventListener('click', function(e) {
        const rect = this.getBoundingClientRect();
        const ripple = document.createElement('span');
        ripple.classList.add('ripple');
        ripple.style.left = `${e.clientX - rect.left}px`;
        ripple.style.top = `${e.clientY - rect.top}px`;
        this.appendChild(ripple);

        setTimeout(() => ripple.remove(), 600);
      });
    });
  }

  // Scroll progress indicator
  function initScrollProgress() {
    const progressBar = document.querySelector('.scroll-progress');
    if (!progressBar) return;

    let ticking = false;
    let docHeight = document.documentElement.scrollHeight - window.innerHeight;

    window.addEventListener('resize', () => {
      docHeight = document.documentElement.scrollHeight - window.innerHeight;
    }, { passive: true });

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset;
          const scrollPercent = (scrollTop / docHeight) * 100;
          progressBar.style.width = `${scrollPercent}%`;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // Floating animation for elements
  function initFloatingElements() {
    const floatingEls = document.querySelectorAll('.floating');

    floatingEls.forEach((el, index) => {
      el.style.animationDelay = `${index * 0.2}s`;
    });
  }

  // Header scroll effect
  function initHeaderScroll() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    let lastScroll = 0;
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const currentScroll = window.pageYOffset;

          if (currentScroll > 100) {
            header.classList.add('header-scrolled');
          } else {
            header.classList.remove('header-scrolled');
          }

          lastScroll = currentScroll;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // Smooth anchor scrolling
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // Initialize everything
  function init() {
    initAnimations();
    animateCounters();
    initParallax();
    initMagneticButtons();
    initImageReveals();
    initTiltEffect();
    initRippleEffect();
    initScrollProgress();
    initFloatingElements();
    initHeaderScroll();
    initSmoothScroll();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', init);
})();
